import { memo } from "react";
import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";

/**
 * FAQ Section - HOMEPAGE VERSION
 * 
 * 4 commercial/hybrid questions, 2-column grid on desktop, 
 * all answers visible by default for crawlability.
 */
const faqs = [
  {
    question: "Är THCA lagligt i Sverige 2026?",
    answer: "Ja, THCA är inte narkotikaklassat i Sverige per 2026. Till skillnad från THC finns THCA inte med på Läkemedelsverkets förteckning över kontrollerade substanser. THCA är den naturliga syraformen av THC som förekommer i hampaväxter och är i sig icke-psykoaktiv. Alla våra produkter uppfyller gällande svensk lagstiftning och är labbtestade av oberoende laboratorier. Vi rekommenderar dock att alltid kontrollera aktuella regler hos Läkemedelsverket, då lagstiftningen kan komma att uppdateras.",
  },
  {
    question: "Hur snabbt levererar ni THCA vapes i Sverige?",
    answer: "Beställningar som läggs före kl 14:00 på vardagar skickas samma dag med PostNord. Normal leveranstid är 1–3 vardagar till hela Sverige. Alla paket skickas diskret utan synlig produktinformation och du får ett spårningsnummer via e-post direkt när paketet lämnar vårt lager. Fri frakt gäller på alla beställningar över 499 kr. Vi prioriterar snabb och pålitlig leverans så att du får dina produkter så fort som möjligt.",
  },
  {
    question: "Hur stark är en Magic Sauce THCA vape?",
    answer: "Magic Sauce är vår starkaste THCA vape med 99 % renhet och 2 ml kapacitet, vilket ger cirka 1 000 puffar per enhet. Det gör den till en av de mest potenta THCA-produkterna på den svenska marknaden. För dig som är ny till THCA rekommenderar vi Snozy-serien med cirka 80 % renhet – en mildare introduktion utan att kompromissa med kvaliteten. Alla våra vapes är labbtestade för renhet, potens och föroreningar.",
  },
  {
    question: "Vilka betalningsmetoder accepterar ni?",
    answer: "Vi accepterar Visa, Mastercard och Revolut för säkra och smidiga betalningar. Alla transaktioner sker via krypterade anslutningar för att skydda dina uppgifter. Vi erbjuder även paketpriser där du kan spara upp till 25 % på utvalda produkter. Om du har frågor om betalning eller behöver hjälp med din beställning kan du alltid kontakta vår kundtjänst via e-post för snabb hjälp.",
  },
];

export const FAQ = memo(() => {
  return (
    <section id="faq" className="py-16 md:py-20 relative overflow-hidden bg-card/20">
      <div className="container mx-auto px-4 relative">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/15 border border-primary/40 mb-5">
            <HelpCircle className="w-4 h-4 text-primary" />
            <span className="text-sm font-bold text-primary">FAQ</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Vanliga frågor om THCA &amp; Magic Sauce Vape i Sverige
          </h2>
          <p className="text-base text-foreground/70 max-w-xl mx-auto">
            Svar på de vanligaste frågorna om våra produkter, leverans och betalning
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-card/80 border border-border/50 rounded-xl p-5"
            >
              <h3 className="font-bold text-base text-foreground mb-3">
                {faq.question}
              </h3>
              <p className="text-foreground/80 leading-relaxed text-sm">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        {/* Link to informational content on blogs */}
        <div className="mt-8 text-center">
          <p className="text-sm text-muted-foreground mb-3">
            Vill du veta mer om THCA och laglighet?
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/blogg/vad-ar-thca"
              className="text-sm text-primary hover:underline font-medium"
            >
              Vad är THCA? →
            </Link>
            <Link
              to="/blogg/thca-vape-sverige"
              className="text-sm text-primary hover:underline font-medium"
            >
              Är THCA lagligt i Sverige? →
            </Link>
            <Link
              to="/faq"
              className="text-sm text-primary hover:underline font-medium"
            >
              Alla frågor →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
});

FAQ.displayName = "FAQ";
export default FAQ;
